import { Injectable, Provider, inject } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable()
export class AddHeadersInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Get code from localStorage directly (works in Capacitor)
    const code = localStorage.getItem('code');
    
    console.log('🔵 Interceptor - code from localStorage:', code);
    console.log('🔵 Interceptor - request URL:', req.url);
    
    // Only add code header if code exists
    if (code) {
      const authReq = req.clone({
        headers: req.headers.set('code', code)
      });
      console.log('🟢 Interceptor - Adding code header:', code);
      return next.handle(authReq);
    }
    
    console.log('🔴 Interceptor - No code found, request without header');
    return next.handle(req);
  }
}

export const addHeadersInterceptor: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AddHeadersInterceptor,
  multi: true,
};
